import { createLink } from '@tanstack/react-router'

import { ComponentProps, type ForwardedRef } from 'react'
import { cn } from '../utils'

type Props = ComponentProps<'a'>

const ForwardRefComponent = ({
  ref,
  className,
  ...props
}: Props & {
  ref: React.RefObject<unknown>
}) => {
  return (
    <a
      {...props}
      className={cn('text-sm text-brand-700 decoration-brand-300/50 hover:underline', className)}
      ref={ref}
    />
  )
}

ForwardRefComponent.displayName = 'Link'

export const Link = createLink(ForwardRefComponent)
